import React, { useEffect } from 'react';

const Alert = ({ message, onClose }) => {
  // Escape closes it — the old dialog could only be dismissed by hitting OK.
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-5 bg-black/70 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="ui-card w-full max-w-[380px] p-7 text-center shadow-pop"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-12 h-12 rounded-xl mx-auto mb-4 flex items-center justify-center bg-rose-500/12 border border-rose-500/30">
          <i className="fas fa-triangle-exclamation text-rose-400" />
        </div>
        <p className="text-sm leading-relaxed text-slate-300 mb-6">{message}</p>
        <button onClick={onClose} className="ui-btn-ghost w-full">Dismiss</button>
      </div>
    </div>
  );
};

export default Alert;
